import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TourNavigation from './tour-navigation';

function TourStep (props){
  const setTextPosition = (targetPosition = {}, position) => {
    const { top: itemTop, left: itemLeft, height } = targetPosition;
    let stepTop, stepLeft, translateX, translateY, maxWidth;
    maxWidth = window.innerWidth - itemLeft - 52;
    switch(position) {
      case 'top':
        stepTop = itemTop - 12;
        translateY = '-100%';
        stepLeft = props.isMobile ? '50%' : itemLeft; 
        translateX = props.isMobile ? '-50%' : 0;
        break;
      case 'bottom':
        stepTop = itemTop + 12;
        translateY = height + 'px';
        stepLeft = props.isMobile ? '50%' : itemLeft; 
        translateX = props.isMobile ? '-50%' : 0;
        break;
      default:
        stepTop = stepLeft = '50%';
        translateX = translateY = '-50%';
    }
    return {
      top: stepTop,
      left: stepLeft,
      maxWidth: device === 'desktop' ? maxWidth : 'unset',
      transform: `translate(${translateX}, ${translateY})`
    }
  }

  const setPointerPosition = (targetPosition) => {
    if (_.isEmpty(targetPosition)) return {};
    const { width, left } = targetPosition;
    const targetCenter = left + width / 2;
    const newLeft = props.isMobile
      ? Math.round(targetCenter * 100 / window.innerWidth) + '%'
      : width / 2;
    return {
      left: newLeft,
      transform: `translateX(-50%)`
    }
  }

  const { translatedMessage, textPosition, targetItemPosition, onClose } = props;
  const positionStyle = setTextPosition(targetItemPosition, textPosition);
  const pointerStyle = setPointerPosition(targetItemPosition);

  return (
    <div className="myad-tour-step" style={positionStyle}>
      <button className="close-btn" onClick={onClose}>✕</button>
      <div className="myad-tour-step__message" dangerouslySetInnerHTML={{ __html: translatedMessage }}></div>
      <TourNavigation {...props}/>
      <div className={`myad-tour-pointer myad-tour-pointer--${textPosition || 'center'}`} 
        style={pointerStyle} />
    </div>
  );
}

TourStep.propTypes = {
  textPosition: PropTypes.oneOf(['top', 'bottom', 'center']),
  targetItemPosition: PropTypes.object,
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export default TourStep;